import { z } from "zod";
import { Commodities } from "../../commodity";

export enum AcceptedCommodity {
  Corn = "Corn",
  Soybeans = "Soybeans",
  KcWinterWheatHrw = "KC Winter Wheat HRW",
  MnSpringHrsw = "MN Spring Wheat HRSW",
  ChicagoWinterWheatSrw = "CHI Winter Wheat SRW",
  Oats = "Oats",
  Sorghum = "Sorghum",
  SoybeanMeal = "Soybean meal",
  Canola = "Canola",

  Sunflowers = "Sunflowers",
  Barley = "Barley",
  Durum = "Durum",
}

export const AcceptedCommodityType = {
  [AcceptedCommodity.Corn]: Commodities.Corn,
  [AcceptedCommodity.Soybeans]: Commodities.Soybeans,
  [AcceptedCommodity.KcWinterWheatHrw]: Commodities.WinterWheat,
  [AcceptedCommodity.MnSpringHrsw]: Commodities.MinneapolisWheat,
  [AcceptedCommodity.ChicagoWinterWheatSrw]: Commodities.WinterWheat,
  [AcceptedCommodity.Oats]: Commodities.Oats,
  [AcceptedCommodity.Sorghum]: "",
  [AcceptedCommodity.SoybeanMeal]: Commodities.SoybeanMeal,
  [AcceptedCommodity.Canola]: Commodities.Canola,
  [AcceptedCommodity.Sunflowers]: Commodities.Sunflowers,
  [AcceptedCommodity.Barley]: Commodities.Barley,
  [AcceptedCommodity.Durum]: Commodities.Durum,
}

export const acceptedCommodityTypes = Object.keys(AcceptedCommodityType);

export const AcceptedCommoditiesValidation = z.enum([
  AcceptedCommodity.Corn,
  AcceptedCommodity.Soybeans,
  AcceptedCommodity.KcWinterWheatHrw,
  AcceptedCommodity.MnSpringHrsw,
  AcceptedCommodity.ChicagoWinterWheatSrw,
  AcceptedCommodity.Oats,
  AcceptedCommodity.Sorghum,
  AcceptedCommodity.SoybeanMeal,
  AcceptedCommodity.Canola,

  AcceptedCommodity.Sunflowers,
  AcceptedCommodity.Barley,
  AcceptedCommodity.Durum,
]);
